<form [formGroup]="form" (ngSubmit)="createCustomers()" autocomplete=off>
  <div formArrayName="customers">
    <ion-card *ngFor="let customerForm of customersFormArray.controls; let i = index" [formGroupName]="i"
      class="ion-no-margin ion-margin-bottom">

      <ion-card-content>
        <ion-row>
          <ion-col size="12" size-md="6">

            <ion-input fill="outline" [label]="'first.name' | translate" labelPlacement="floating"
              [errorText]="'is.required' | translate: {fieldName: ('first.name' | translate)}" formControlName="firstName"
              [placeholder]="'first.name' | translate" type="text">
            </ion-input>
          </ion-col>

          <ion-col size="12" size-md="6">
            <ion-input fill="outline" [label]="'last.name' | translate" labelPlacement="floating"
              [errorText]="'is.required' | translate: {fieldName: ('last.name' | translate)}" formControlName="lastName"
              [placeholder]="'last.name' | translate" type="text">
            </ion-input>
          </ion-col>

        </ion-row>

        <ion-row>
          <ion-col size="12" size-md="6">
            <ion-input fill="outline" labelPlacement="floating" [errorText]="'customer.phone.number.invalid' | translate"
              [helperText]="'is.optional' | translate: {fieldName: ('phone.number' | translate)}"
              formControlName="phoneNumber" [placeholder]="'phone.number' | translate" type="tel">
            </ion-input>
          </ion-col>

          <ion-col size="12" size-md="6">
            <ion-input fill="outline" labelPlacement="floating" [errorText]="'email.format.invalid' | translate"
              [helperText]="'is.optional' | translate: {fieldName: ('email' | translate)}" formControlName="email"
              [placeholder]="'email' | translate" type="email">
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center ion-justify-content-between">
          {{ 'customer.bulk.add.notes.total' | translate: { total: customerForm.value.notes.length } }}
          <ion-button fill="outline" color="danger" size="small" (click)="removeCustomer(i)">
            <ion-icon name="trash-outline" slot="start"></ion-icon>
            {{ 'customers.bulk.remove' | translate }}
          </ion-button>

        </ion-row>
      </ion-card-content>
    </ion-card>
  </div>

  <ion-row class="ion-margin-top ion-justify-content-end buttons-container">

    <ion-button expand="block" fill="outline" (click)="addCustomer()">
      <ion-icon name="person-add-outline" slot="start"></ion-icon>
      {{ 'customers.add.another' | translate }}
    </ion-button>

    <ion-button color="secondary" expand="block" type="submit" [disabled]="!isFormValid">
      <ion-icon name="people-outline" slot="start"></ion-icon>
      {{ bulkCreateButtonText }}
    </ion-button>

  </ion-row>
</form>
